import gql from 'graphql-tag'

export default gql`
{
  offices{
    id
    description
    active_users{
      user_id
      full_name
    }
  }
}
`